import Hook from "./libs/snake.lib.hook.js";
import Trace from "./libs/snake.lib.trace.js";
import config from "./config.js";

export default class ComponentCommerceBanner {
    static modalI18nGenericOptions;

    static init = async () => {
        Trace.debug("Component _cmpCommerceBanner");
        Trace.debug(window.snakeCheckout.commerceBanners);

        let show = false;
        const componentDom = document.querySelectorAll("." + config.routing.sections.commerceBanner.component);

        componentDom.forEach((component) => {
            Object.entries(window.snakeCheckout.commerceBanners).forEach(([key, value]) => {
                component.appendChild(document.querySelector("template.tpl-banner").content.cloneNode(true));

                const element = component.lastElementChild;
                const elementButton = element.querySelector("button");

                elementButton.setAttribute("id", elementButton.getAttribute("id") + "_" + key);
                elementButton.dataset.sku = value.sku;

                element.querySelector(".commerce-banner-background > div > div:first-child").innerHTML = value.text || "";

                if (value.image) {
                    element.querySelector("img").src = value.image;
                } else {
                    component.classList.add("no-image");
                }

                element.classList.remove("hidden");
                show = true;
            });

            if (show) {
                component.lastElementChild?.classList.remove("mb-3");
                component.classList.remove("hidden");
            }
        });

        if (show) {
            Hook.attachListeners();

            /**
             * Listener to intercept the Commerce Banner user action
             */
            Hook.subscribe("_setCommerceVariant", (e) => {
                window.location.href = "/" + config.countries[window.snakeCheckout.currentCountry].countryCode.toLowerCase() + "/subscribe?sku=" + e.detail.event.target.dataset.sku;
            });
        }
    };
}
